module.exports = __webpack_public_path__ + "static/media/delete_black.522681f3.svg";